<template>
    <a-form-model
        layout="horizontal"
        :model="form"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 20 }"
        class="company-info-form"
        ref="companyInfoForm"
        :rules="rules"
    >
        <a-form-model-item label="企业类型">
            <a-input v-model="form.kehuType" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="企业名称" prop="compName">
            <a-input v-model="form.compName" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="企业地址" prop="detailAddress">
            <a-input v-model="form.detailAddress" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="法人信息">
            <a-input v-model="form.legal" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="组织机构代码">
            <a-input v-model="form.unifiedSocialCreditCode" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="营业执照">
            <div class="upload" v-if="fileList.length < 1">
                <a-upload
                    list-type="picture-card"
                    action="string"
                    ref="upload"
                    class="avatar-uploader"
                    accept=".jpg, .jpeg, .png, .pdf"
                    :show-upload-list="false"
                    :file-list="fileList"
                    :before-upload="beforeFileUpload"
                    @change="imgStatus"
                >
                    <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
            </div>
        </a-form-model-item>
    </a-form-model>
</template>

<script>
export default {
    data() {
        return {
            form: {
                kehuType: '',
                compName: '',
                detailAddress: '',
                legal: '',
                unifiedSocialCreditCode: ''
            },
            params: {},
            imageUrl: '',
            rules: {
                compName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
                detailAddress: [{ required: true, message: '用户名不能为空', trigger: 'blur' }]
            },
            fileList: []
        };
    },
    methods: {
        validate() {
            return new Promise(res => {
                this.$refs.companyInfoForm.validate(valid => {
                    if (valid) {
                        res(true);
                    } else {
                        res(false);
                    }
                });
            });
        },

        resetFields() {
            this.$refs.companyInfoForm.resetFields();
        },

        imgStatus(file) {
            this.params.businessLicenseFile = file.raw;
            this.params.businessLicenseName = file.name;
            const obj = {
                file: file.raw,
                name: file.name
            };
            this.fileList.push(obj);
            this.imageUrl = URL.createObjectURL(file.raw);
        },

        // 上传格式校验
        beforeFileUpload(file) {
            const size = file.size / 1024 / 1024 < 50;
            if (!size) {
                return this.$message.error('图片文件不能大于50M!');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.company-info-form {
    .ant-form-item {
        .ant-upload-select-picture-card i {
            font-size: 32px;
            color: #999;
        }

        .ant-upload-select-picture-card .ant-upload-text {
            margin-top: 8px;
            color: #666;
        }
    }
}
</style>
